import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer } from 'utils/redux-injectors';
import { AssetsSelectionState } from './types';

export const initialState: AssetsSelectionState = {
  filters: undefined,
  loading: undefined,
};

const slice = createSlice({
  name: 'assetsSelection',
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<Record<string, any> | undefined>) {
      state.filters = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    reset(state, action: PayloadAction) {
      state.filters = undefined;
      state.loading = undefined;
    },
  },
});

export const { actions: assetsSelectionActions } = slice;

export const useAssetsSelectionSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  // useInjectSaga({ key: slice.name, saga: assetsSelectionSaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useAssetsSelectionSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
